module.exports = __webpack_public_path__ + "assets/madcap-software.79c85db5.svg";